export enum BorrowNoteType {
    Efetivo = 1,
    NotaEmpresta = 2
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/BorrowNote.ts